import { endpoints } from '@/config';
import get from './get';

/**
 * @param {string} view - ['raw', undefined]
 */
export default async function getTemporaryKpiResult(accountId, kpi, {
  pivotProperty,
  deviceTimezoneInput,
  period,
  offset,
  view,
  decompile,
  range,
  scope,
} = {}) {
  const overrides = {
    method: 'POST',
    url: endpoints.kpi,
    data: kpi,
  };
  return get(overrides, {
    accountId,
    pivotProperty,
    deviceTimezoneInput,
    period,
    offset,
    view,
    decompile,
    range,
    scope,
  }, { kpi });
}
